import React from "react";

import { Chip } from "@mui/material";

import { SENSOR_CHIP_SX } from "components/sensors/table/chips/sensor-chip-style";
import { SENSOR_STATUS_COLOR } from "components/sensors/table/chips/sensor-status-color";

const PILL_WIDTH = "64px";

export function BatteryStatusChip({
  lowBattery,
}: {
  lowBattery: boolean | undefined;
}) {
  const pillColor = lowBattery
    ? SENSOR_STATUS_COLOR.caution
    : SENSOR_STATUS_COLOR.positive;
  return (
    <Chip
      size="small"
      label={lowBattery ? "Low" : "OK"}
      sx={{ ...SENSOR_CHIP_SX, width: PILL_WIDTH, ...pillColor }}
    />
  );
}
